import React, { useEffect, useState } from 'react';
import useApiManager from 'networking/ApiManager';
import { editTheme, search, trashRed } from 'res/images';
import { Modal } from 'rsuite';
import { MedicineForm } from 'whealth-core-web/forms';
import CommonBorderBox from './CommonBorderBox';
import { dateFormat, timeFormat, teamRoles } from './Helper';
import Pagination from './Pagination';
import CoreInputBox from './CoreInputBox';
import EmptyView from './EmptyView';
import CommonToolTip from './CommonToolTip';
import { useGetLoginUserDataQuery } from 'redux/apiSlice';

function DraftedMedicine(props) {
  const { setIsLoading, isLoading, setIsShowAlert, setAlertType } = props;
  const ApiClient = useApiManager();
  const userData = useGetLoginUserDataQuery()?.data?.data || {};
  const [updateData, setupdateData] = useState('');
  const [error, seterror] = useState('');
  const [listData, setListData] = useState([]);
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchInput, setSearchInput] = useState('');
  const [fuzzyMatches, setFuzzyMatches] = useState([]);
  const [showFuzzyModal, setShowFuzzyModal] = useState(false);

  let timeOut;

  useEffect(() => {
    if (!searchInput || searchInput?.trim()?.length == 0) {
      getDraftedMedicineList();
    }
  }, [currentPage, searchInput?.trim()?.length == 0]);

  useEffect(() => {
    timeOut = setTimeout(() => {
      if (searchInput?.trim()?.length > 2) {
        searchMedicines();
        setTotalPages(1);
      }
    }, 300);
  }, [searchInput]);

  const searchMedicines = () => {
    setIsLoading(true);
    ApiClient.searchMedicinesName(searchInput)
      .then((res) => {
        setIsLoading(false);
        setListData(res.data?.filter((item) => item.status === 'draft'));
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const getDraftedMedicineList = () => {
    setIsLoading(true);
    const pageQry = { page: currentPage, status: 'draft' };
    ApiClient.getMedicinesSetting(pageQry)
      .then((res) => {
        setIsLoading(false);
        setTotalPages(res.headers['total-pages']);
        setListData(res.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const createMedicinesApprove = (item) => {
    seterror([]);
    setIsLoading(true);
    ApiClient.createMedicinesApprove(item.id)
      .then((res) => {
        setIsLoading(false);
        getDraftedMedicineList();
        setAlertType('alert-success');
        setIsShowAlert('Medicine Approved Successfully.');
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertType('alert-danger');
        if (err.response?.data?.detail) {
          setIsShowAlert(err.response.data.detail);
        } else {
          seterror(err.response?.data?.errors);
        }
      });
  };

  const createMedicinesUnApprove = (item) => {
    seterror([]);
    setIsLoading(true);
    ApiClient.createMedicinesUnApprove(item.id)
      .then((res) => {
        setIsLoading(false);
        getDraftedMedicineList();
        setAlertType('alert-success');
        setIsShowAlert('Medicine Disapproved Successfully.');
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertType('alert-danger');
        if (err.response?.data?.detail) {
          setIsShowAlert(err.response.data.detail);
        } else {
          seterror(err.response?.data?.errors);
        }
      });
  };

  const updateMedicines = () => {
    if (updateData?.status === 'published') {
      setIsLoading(true);
      const searchStr = updateData?.name || '';
      ApiClient.fuzzySearchMedicines(searchStr, updateData?.id)
        .then((res) => {
          setIsLoading(false);
          const results = res.data?.results || [];
          if (results.length > 0) {
            setFuzzyMatches(results);
            setShowFuzzyModal(true);
          } else {
            performUpdate();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          performUpdate();
        });
    } else {
      performUpdate();
    }
  };

  const performUpdate = () => {
    ApiClient.updateMedicines(updateData.id, updateData)
      .then((res) => {
        setAlertType('alert-success');
        setIsShowAlert('Medicine Updated Successfully.');
        getDraftedMedicineList();
        handleModalClose();
        setShowFuzzyModal(false);
        setFuzzyMatches([]);
      })
      .catch((err) => {
        setAlertType('alert-danger');
        if (err.response?.data?.detail) {
          setIsShowAlert(err.response.data.detail);
          setOpen(false);
        } else {
          seterror(err.response?.data?.errors);
        }
      });
  };

  const deleteData = (id) => {
    seterror([]);
    const windowConfirm = window.confirm('Are you sure you want to delete ?');
    if (windowConfirm) {
      ApiClient.deleteMedicines(id)
        .then((res) => {
          setAlertType('alert-success');
          setIsShowAlert(res.data.message);
          getDraftedMedicineList();
        })
        .catch((err) => {
          setAlertType('alert-danger');
          setIsShowAlert(err.response?.data?.detail || err.response?.data?.message);
        });
    }
  };

  const handleModalClose = () => {
    setOpen(false);
    setupdateData({});
    seterror('');
  };

  const updateDataModalOpen = (data) => {
    setOpen(true);
    data.medicine_category_title = data.medicine_category;
    setupdateData(data);
    seterror('');
  };

  const updateModal = () => {
    return (
      <div>
        <Modal backdrop='static' size='md' open={open} onClose={handleModalClose}>
          <Modal.Header />
          <div className='commonBorderBox settingFormOutline mb-4'>
            <MedicineForm
              error={error}
              valueObj={updateData}
              setValueObj={setupdateData}
              isUpdate={true}
              onClick={updateMedicines}
            />
          </div>
        </Modal>
      </div>
    );
  };

  const listDataMap = () => {
    return listData.map((item, index) => {
      return (
        <tr key={index} className='my-3 font-12px'>
          <table className='table'>
            <tr>
              <td colSpan={2}>
                <div className='d-flex mb-1 align-items-center justify-content-between'>
                  <div className='align-items-flex-start'>
                    <div className='medicinename'>{item.name}</div>
                    <div className='badge capitalize lightGrayBadge mt-2'>{item.status}</div>
                  </div>
                  <div
                    className='d-flex text-muted justify-content-between align-items-center medicineDataList'
                    style={{ gap: '10px' }}
                  >
                    <div className='capitalize'>
                      Created by · {item?.admin?.full_name} ({teamRoles(item?.admin?.role)})
                    </div>
                    <div>
                      Created at · {dateFormat(item.created_at)} . {timeFormat(item.created_at)}
                    </div>
                    {!userData?.read_only && (
                      <div className='action-images d-flex'>
                        <CommonToolTip
                          placement={'top'}
                          item={<img onClick={() => updateDataModalOpen(item)} src={editTheme} />}
                          showValue={'Edit'}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan={2} className='medicinesCategoryInfo'>
                {(item.medicine_category || item.shorter_composition) && (
                  <div className='medicinesCategoryInfo d-flex'>
                    {item.medicine_category && (
                      <div className='text-nowrap me-3'>
                        <strong>{item.medicine_category}</strong>
                      </div>
                    )}
                    {item.shorter_composition && (
                      <div className='text-muted flex-wrap'>{item.shorter_composition}</div>
                    )}
                  </div>
                )}
              </td>
            </tr>
          </table>
        </tr>
      );
    });
  };

  const patination = () => {
    return (
      <Pagination
        seterror={seterror}
        totalPages={totalPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    );
  };

  const handleChange = async (text) => {
    clearTimeout(timeOut);
    setSearchInput(text);
  };

  const renderSearchInput = () => {
    return (
      <div className='mb-3'>
        <CoreInputBox
          placeholder='Search Draft Medicine By Category Or Name'
          value={searchInput}
          setValue={handleChange}
          leftIcon={search}
        />
      </div>
    );
  };

  const renderEmptyView = () => {
    return <EmptyView title='No drafted medicines found' />;
  };

  return (
    <div className='medicine-form'>
      <CommonBorderBox>{renderSearchInput()}</CommonBorderBox>
      <div className='table-responsive'>
        <table className='w-100'>{listData?.length > 0 ? listDataMap() : renderEmptyView()}</table>
      </div>
      <div className='d-flex justify-content-end mt-3'>{patination()}</div>
      {updateModal()}

      {/* Fuzzy Match Modal */}
      <Modal backdrop='static' size='md' open={showFuzzyModal} onClose={() => setShowFuzzyModal(false)}>
        <Modal.Header>
          <h5>Similar Medicines Found</h5>
        </Modal.Header>
        <Modal.Body>
          <p style={{ marginBottom: '12px', color: '#555' }}>
            The following existing medicines match your entry. Do you still want to update?
          </p>
          <div className='table-responsive'>
            <table className='table table-bordered'>
              <thead>
                <tr style={{ backgroundColor: '#f5f5f5' }}>
                  <th>Name</th>
                  <th>Composition</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {fuzzyMatches.map((item, index) => (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td style={{ fontSize: '11px', color: '#666' }}>{item.shorter_composition || item.info || '-'}</td>
                    <td><span className='badge capitalize lightGrayBadge'>{item.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-secondary me-2' onClick={() => setShowFuzzyModal(false)}>
            Cancel
          </button>
          <button className='btn btn-primary' onClick={() => performUpdate()}>
            Update Anyway
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default DraftedMedicine;
